<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import defaultConfig from '@/settings'
import {setTitle, setCssVar, hexToRgb} from '@/utils/index'
import store from '@/store'
export default {
  name: 'app',
  data() {
    return {
      theme: '',
      desc: '',
      keyword: '',
      siteTitle: '花卷云'
    }
  },
  created() {
    this.getSysConfig()
  },
  methods: {
    async getSysConfig() {  
        try { 
            // await this.$store.dispatch('config/clearCfg') // 先清除原有配置，再重新请求
            const res = await this.$store.dispatch('config/getThemeCfg')
            this.theme = res.webtool_color || defaultConfig.defaultTheme 
            this.siteTitle = `${res.webtool_login_slogon}`
            this.setSiteCfg()
        } catch (error) {  
          console.log(error)
        }  
    },
    setSiteCfg() {
      // 设置主题色
      setCssVar('--main-bg-color', this.theme)
      const themeColorRgb = hexToRgb(this.theme)
      setCssVar("--theme-color-rgb", themeColorRgb);
      // 设置网页title
      setTitle({
          site_title: this.siteTitle
        });
      }
    }
}
</script>

<style lang="scss">
@import "styles/custom-theme.scss";
@font-face {
	font-family: 'customFont';
	src: url('./assets/fonts/DHUDC1.01-Bold.ttf') format("truetype");
}
.customFont {
  font-family: customFont;
}


   
</style>
